"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapShippingMethods = function mapShippingMethods(shippingMethods) {
  return shippingMethods.map(function (method) {
    return {
      id: method.carrier_code,
      label: method.carrier_title,
      methodCode: method.method_code,
      carrierCode: method.carrier_code,
      price: method.amount
    };
  });
};
var _default = mapShippingMethods;
exports["default"] = _default;